import { CreatedByModel } from "../created-by-model";
import { CustomDropDown } from "../custom-dropdown";

export namespace ClientModels {
  export interface IClient {
    clientId: number;
    clientName: string;
    serviceProviderId: number;
    isActive: boolean;
    createdOn: Date;
    createdById: number;
    updatedOn: Date;
    updatedById: number;
    jobTitle: string;
    departmentName: string;
    clientTypeId: number;
    hasCompanyBanner: boolean;
    companyBanner: string;
    billableContact: BillableContact[];
    alternateName: string;
  }

  export class Client extends CreatedByModel {
    public clientId: number;
    public clientName: string;
    public billingName: string;
    public clientStatusId: number;
    public clientStatusText: string;
    public serviceProviderId: number;
    public isActive: boolean;
    public locations: ClientLocation[];
    public webDomains: ClientWebDomain[];
    public contactsCount!: number;
    public hideToolTip: boolean = true;
    public antivirus!: number;
    public antivirusConfig!: string;
    public clientTypeId: number;
    public hasCompanyBanner: boolean;
    public companyBanner: string;
    public billableContact: BillableContact[];
    public alternateName: string;
    public trackingCategoryJson: string;

    constructor(
      clientId: number,
      clientName: string,
      clientStatusId: number,
      serviceProviderId: number,
      isActive: boolean,
      locations: ClientLocation[],
      webDomains: ClientWebDomain[],
      billingName: string,
      clientTypeId: number,
      hasCompanyBanner: boolean,
      companyBanner: string,
      billableContact: BillableContact[],
      alternateName: string,
      createdOn?: Date,
      updatedOn?: Date,
      createdById?: number,
      updatedById?: number,
      clientStatusText: string = "",
      trackingCategoryJson: string = "",
    ) {
      super(createdOn, updatedOn, createdById, updatedById);
      this.clientId = clientId;
      this.clientName = clientName;
      this.clientStatusId = clientStatusId;
      this.serviceProviderId = serviceProviderId;
      this.isActive = isActive;
      this.locations = locations;
      this.webDomains = webDomains;
      this.clientStatusText = clientStatusText;
      this.billingName = billingName;
      this.clientTypeId = clientTypeId;
      this.hasCompanyBanner = hasCompanyBanner;
      this.companyBanner = companyBanner;
      this.billableContact = billableContact;
      this.alternateName = alternateName;
      this.trackingCategoryJson = trackingCategoryJson;
    }
  }
  export class ClientState {
    public clientName!: string;
    public billingName!: string;
    public alternateNames!: string[];
    public clientTypeId!: number;
    public groupId!: string[];
    public clientLocations!: ClientLocation[];
    public clientWebDomains!: ClientWebDomain[];
  }

  export class ClientCreateState {
    public clientName!: string;
    public billingName!: string;
    public alternateNames!: string[];
    public clientTypeId!: number;
    public groupId!: string[];
    public clientLocation!: ManageClientLocation | null;
    public clientWebDomain!: string;
    public primaryContact!: any;
    public billingContacts!: any[];
    billingContactKey!: number;
  }

  export class ClientLocation extends CreatedByModel {
    public clientLocationId: number;
    public isDefault: boolean;
    public isActive: boolean;
    public clientLocationName: string;
    public address1: string;
    public address2: string;
    public city: string;
    public state: string;
    public country: string;
    public phone: string;
    public phoneExt: string;
    public zipCode: string;
    public locationTypeId: number | null;
    public locationTypeName: string | null;
    public clientId: number;
    public timeZone: string | null;
    public contactId: number | null;
    public index: number;
    public geolocation: string;
    public geoLocationLatitude: string;
    public geoLocationLongitude: string;
    public isDefaultBillingLocation: boolean;
    public billingContacts!: string;
    public searchForAllClients?: boolean;

    constructor(
      clientLocationId: number,
      isActive: boolean,
      isDefault: boolean,
      clientLocationName: string,
      address1: string,
      address2: string,
      city: string,
      state: string,
      country: string,
      phone: string,
      phoneExt: string,
      zipCode: string,
      locationTypeId: number | null,
      locationTypeName: string | null,
      clientId: number,
      timeZone: string | null,
      contactId: number | null,
      index: number,
      geolocation: string,
      geoLocationLatitude: string,
      geoLocationLongitude: string,
      isDefaultBillingLocation: boolean,
      createdOn?: Date,
      updatedOn?: Date,
      createdById?: number,
      updatedById?: number,
      searchForAllClients?: boolean,
    ) {
      super(createdOn, updatedOn, createdById, updatedById);
      this.clientLocationId = clientLocationId;
      this.isDefault = isDefault;
      this.clientLocationName = clientLocationName;
      this.address1 = address1;
      this.address2 = address2;
      this.city = city;
      this.state = state;
      this.country = country;
      this.phone = phone;
      this.phoneExt = phoneExt;
      this.zipCode = zipCode;
      this.locationTypeId = locationTypeId;
      this.locationTypeName = locationTypeName;
      this.clientId = clientId;
      this.isActive = isActive;
      this.timeZone = timeZone;
      this.contactId = contactId;
      this.index = index;
      this.geolocation = geolocation;
      this.geoLocationLatitude = geoLocationLatitude;
      this.geoLocationLongitude = geoLocationLongitude;
      this.isDefaultBillingLocation = isDefaultBillingLocation;
      this.searchForAllClients = searchForAllClients;
    }
  }

  export class ClientLocationType extends CreatedByModel {
    public clientLocationTypeId!: number;
    public clientLocationTypeName!: string;
  }

  export class ClientStatus extends CreatedByModel {
    public clientStatusId: number;
    public clientStatusName: string;
    public isActive: boolean;

    constructor(
      clientStatusId: number,
      clientStatusName: string,
      isActive: boolean,
      createdOn?: Date,
      updatedOn?: Date,
      createdById?: number,
      updatedById?: number,
    ) {
      super(createdOn, updatedOn, createdById, updatedById);
      this.clientStatusId = clientStatusId;
      this.clientStatusName = clientStatusName;
      this.isActive = isActive;
    }
  }

  export class ClientWebDomain extends CreatedByModel {
    public clientWebDomainId: number;
    public clientWebDomainName: string;
    public clientId: number;
    public statusId: number;
    public statusName: string;
    public index: number;

    constructor(
      clientWebDomainId: number,
      clientWebDomainName: string,
      clientId: number,
      statusId: number,
      statusName: string,
      index: number,
      createdOn?: Date,
      updatedOn?: Date,
      createdById?: number,
      updatedById?: number,
    ) {
      super(createdOn, updatedOn, createdById, updatedById);
      this.clientWebDomainId = clientWebDomainId;
      this.clientWebDomainName = clientWebDomainName;
      this.clientId = clientId;
      this.statusId = statusId;
      this.statusName = statusName;
      this.index = index;
    }
  }

  export class ManageClientLocation extends ClientLocation {
    public isEditMode: boolean;
    public isSaving: boolean = false;

    constructor(
      clientLocationId: number,
      isDefault: boolean,
      clientLocationName: string,
      address1: string,
      address2: string,
      city: string,
      state: string,
      country: string,
      phone: string,
      phoneExt: string,
      zipCode: string,
      locationTypeId: number | null,
      locationTypeName: string | null,
      clientId: number,
      timeZone: string,
      contactId: number | null,
      isActive: boolean,
      index: number,
      isEditMode: boolean,
      geolocation: string,
      geoLocationLatitude: string,
      geoLocationLongitude: string,
      isDefaultBillingLocation: boolean,
      createdOn?: Date,
      updatedOn?: Date,
      createdById?: number,
      updatedById?: number,
      searchForAllClients?: boolean,
    ) {
      super(
        clientLocationId,
        isDefault,
        isActive,
        clientLocationName,
        address1,
        address2,
        city,
        state,
        country,
        phone,
        phoneExt,
        zipCode,
        locationTypeId,
        locationTypeName,
        clientId,
        timeZone,
        contactId,
        index,
        geolocation,
        geoLocationLatitude,
        geoLocationLongitude,
        isDefaultBillingLocation,
        createdOn,
        updatedOn,
        createdById,
        updatedById,
        searchForAllClients,
      );

      this.isEditMode = isEditMode;
    }
  }

  export class ManageClientWebdomainDomain extends ClientWebDomain {
    public statusDropdownObject: CustomDropDown.IDropDown;
    public isEditMode: boolean;
    public isValidating: boolean = false;
    public isSaving: boolean = false;
    public isWebDomainUnique: boolean = true;

    constructor(
      isEditMode: boolean,
      statusDropdownObject: CustomDropDown.IDropDown,
      clientWebDomainId: number,
      clientWebDomainName: string,
      clientId: number,
      statusId: number,
      statusName: string,
      index: number,
      createdOn?: Date,
      updatedOn?: Date,
      createdById?: number,
      updatedById?: number,
    ) {
      super(
        clientWebDomainId,
        clientWebDomainName,
        clientId,
        statusId,
        statusName,
        index,
        createdOn,
        updatedOn,
        createdById,
        updatedById,
      );
      this.statusDropdownObject = statusDropdownObject;
      this.isEditMode = isEditMode;
    }
  }

  export class ClientType {
    public clientTypeId: number;
    public clientTypeName: string;
    public serviceProviderId: number;

    public constructor(_id: number, _name: string, _serviceProviderId: number) {
      this.clientTypeId = _id;
      this.clientTypeName = _name;
      this.serviceProviderId = _serviceProviderId;
    }
  }

  export class BillableContact {
    public contactId: number;
    public contactName: string;

    constructor(contactId: number, contactName: string) {
      this.contactId = contactId;
      this.contactName = contactName;
    }
  }

  export class XeroClientMapping {
    public xeroClientObject: CustomDropDown.IDropDown | null;
    public xeroClientObjectKey: number = 0;
    public clientId: number;
    public clientName: string;
    public xeromapId: string;
    public xeromappedClientName: string;
    public isShow: boolean;

    constructor(
      _xeroClientObject: CustomDropDown.IDropDown | null,
      _clientId: number,
      _clientName: string,
      _xeromapId: string,
      _xeromappedClientName: string,
      _isShow: boolean,
    ) {
      this.xeroClientObject = _xeroClientObject;
      this.clientId = _clientId;
      this.clientName = _clientName;
      this.xeromapId = _xeromapId;
      this.xeromappedClientName = _xeromappedClientName;
      this.isShow = _isShow;
    }
  }
}
